<div
  class="ab-user-agent {{ info?.browserName?.replace(' ', '-').toLowerCase() }}"
  title="{{ raw }}"
>
  {{ info?.browserName }} {{ info?.browserVersion }}
</div>
